import React, { useEffect, useState } from 'react'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

import { useUsers } from '../../context/UserContext'
import ButtonPrimaryForm from '../common/ButtonPrimaryForm'
import { IconClose, IconKey, IconSave } from '../icons/Icons'
import Input from '../common/Input'
import Select from '../common/Select'

const UsersForm = ({ user }) => {
    const [formData, setFormData] = useState({
        last_name: '',
        first_name: '',
        email: '',
        password: '',
        rol: '',
        status: true,
        image: null
    })
    const ref = React.useRef();
    const {
        getUser,
        updateUsers,
        createUsers,
        roles,
        getRoles
    } = useUsers();
    const MySwal = withReactContent(Swal)

    useEffect(() => {
        getUserById(user)
        getRoles()
    }, [user])

    async function getUserById(user) {
        if (user !== null) {
            const userData = await getUser(user)
            formData.first_name = userData.first_name
            formData.last_name = userData.last_name
            formData.email = userData.email
            formData.rol = userData.rol_id
        } else {
            ref.current.reset()
        }
    }

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(() => ({
            ...formData,
            [name]: value,
        }));
    }

    const handleImageChange = (e) => {
        const imageFile = e.target.files[0];
        setFormData(() => ({
            ...formData,
            image: imageFile
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault()
        if (user !== null) {
            const resp = await updateUsers(formData, user)
            MySwal.fire({
                title: resp.title,
                text: resp.msg,
                icon: resp.icon,
            })
        } else {
            const resp = await createUsers(formData)
            MySwal.fire({
                title: resp.title,
                text: resp.msg,
                icon: resp.icon,
            })
        }
    }

    return (
        <>
            {
                user != null &&
                <div className='w-full flex flex-col md:flex-row items-center gap-3'>
                    <button className='bg-primary/90 border hover:bg-primary border-primary text-white px-3 py-1 rounded-sm transition-colors duration-300 flex items-center gap-1'>
                        <IconKey className='w-4' />
                        Cambiar contraseña
                    </button>
                    <button className='bg-secondary/90 hover:bg-secondary border border-secondary text-white px-3 py-1 rounded-sm transition-colors duration-300 flex items-center gap-1'>
                        <IconClose className='w-4' />
                        Desactivar usuario
                    </button>
                </div>
            }
            <hr className='my-5' />
            <form onSubmit={handleSubmit} ref={ref}>
                <h4 className='uppercase text-sm font-medium mb-3'>Datos generales</h4>
                <div className='grid grid-cols-3 gap-4'>
                    <div className='col-span-2 flex flex-col gap-y-2 gap-x-10'>
                        <Input
                            textLabel='Nombres:'
                            typeInput={"text"}
                            name={"first_name"}
                            className='w-3/4'
                            required={true}
                            value={formData.first_name}
                            onChange={handleInputChange}
                        />
                        <Input
                            textLabel='Apellidos:'
                            typeInput={"text"}
                            name={"last_name"}
                            className='w-3/4'
                            required={true}
                            value={formData.last_name}
                            onChange={handleInputChange}
                        />
                        <Input
                            textLabel='Email:'
                            typeInput={"email"}
                            name={"email"}
                            className='w-3/4'
                            required={true}
                            value={formData.email}
                            onChange={handleInputChange}
                        />
                        {
                            user === null &&
                            <Input
                                textLabel='Contraseña:'
                                typeInput={"password"}
                                name={"password"}
                                className='w-3/4'
                                required={true}
                                value={formData.password}
                                onChange={handleInputChange}
                            />

                        }
                        <Select
                            textLabel={"Rol:"}
                            name={"rol"}
                            className='w-3/4'
                            value={formData.rol}
                            onChange={handleInputChange}
                            dataOptions={roles}
                            required={true}
                        />
                    </div>
                    <div className='flex justify-end'>
                        <label className="block mb-4 text-sm font-light w-24 h-24 border border-gray-300 object-cover" forhtml="inputImageUser">
                            Foto:
                            <input
                                id='inputImageUser'
                                type="file"
                                className="hidden"
                                name='image'
                                onChange={handleImageChange}
                            />
                        </label>
                    </div>
                </div>
                <div className="flex justify-between items-center gap-2 mt-6">
                    <div className='flex flex-col gap-2'>
                        <span className='text-red-500 italic text-xs'>* Campos obligatorios</span>
                    </div>
                    <div className='flex gap-2 items-center'>
                        <ButtonPrimaryForm text={'Guardar'} typeBtn={'submit'} >
                            <IconSave className='w-4' />
                        </ButtonPrimaryForm>
                    </div>
                </div>
            </form>
        </>
    )
}

export default UsersForm